/*
  Neropos cart, for the new pages (layout/theme.liquid). It adds to the cart through the Ajax API and redraws what the
  cart shows from sections/np-cart.liquid (and the cart page from its own section), so every price, discount and text
  comes from Shopify. «Αγορά»: the drop flies into the bag while the boxes go in, then the drawer comes up as a card
  (np-pages.js, NP.drawer), nothing in it bouncing (the user, 2026-10-19). Without JavaScript the bag goes to /cart and
  the buy button posts the product form. The story's own cart is assets/cart.js.
*/
(function () {
  'use strict';
  var NP = window.NP || (window.NP = {});
  var $ = NP.$, $$ = NP.$$, reduce = NP.reduce, t = NP.tx;
  var SECTION = 'np-cart';

  function plural(key, n, vars) { var v = vars || {}; v.n = n; return t(key + (n === 1 ? '_one' : '_other'), v); }

  /* The shop's own money format, the way Liquid's money filter writes it */
  function money(cents) {
    var format = NP.money || '{{amount}}';
    var m = format.match(/\{\{\s*(\w+)\s*\}\}/);
    if (!m) return format;
    function fmt(dec, th, ds) {
      var parts = (Number(cents || 0) / 100).toFixed(dec).split('.');
      var whole = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + th);
      return parts[1] ? whole + ds + parts[1] : whole;
    }
    var map = {
      amount: [2, ',', '.'],
      amount_no_decimals: [0, ',', '.'],
      amount_with_comma_separator: [2, '.', ','],
      amount_no_decimals_with_comma_separator: [0, '.', ','],
      amount_with_apostrophe_separator: [2, "'", '.'],
      amount_no_decimals_with_space_separator: [0, ' ', ''],
      amount_with_space_separator: [2, ' ', ','],
      amount_with_period_and_space_separator: [2, ' ', '.']
    };
    var o = map[m[1]] || map.amount;
    return format.replace(m[0], fmt(o[0], o[1], o[2]));
  }

  /* The quantity discount the way the store's automatic discounts give it: a share off every box from two or three
     boxes, rounded down, so the page never shows less than the cart will charge */
  function deal(unit, n) {
    var tiers = NP.tiers || [], p2 = Number(tiers[2]) || 0, p3 = Math.max(p2, Number(tiers[3]) || 0);
    var pct = n >= 3 ? p3 : n === 2 ? p2 : 0;
    var full = unit * n, off = Math.floor(full * pct / 100);
    return { full: full, off: off, final: full - off, pct: off > 0 ? pct : 0 };
  }

  /* Every step goes to the data layer and to Shopify's customer events, so we can see where people stop */
  function track(ev, data) {
    var o = { event: ev }, k;
    for (k in data || {}) o[k] = data[k];
    (window.dataLayer = window.dataLayer || []).push(o);
    try {
      if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(ev, data || {});
    } catch (e) { /* analytics never breaks the page */ }
  }

  function request(url, body) {
    return fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (d) {
        if (!r.ok) {
          var err = new Error(d.description || d.message || t('error'));
          err.shown = d.description || d.message || '';
          throw err;
        }
        return d;
      });
    });
  }

  /* ---------- The drawer, and the cart page ---------- */
  var dlg = $('[data-drawer]'), panel = dlg && $('[data-drawer-panel]', dlg), status = $('[data-cart-status]');
  var drawer = NP.drawer ? NP.drawer(dlg, 'cart-on', function (on) { if (on) track('cart_drawer_open', {}); }) : null;
  var pageRoot = $('[data-cartpage]'), pageSection = pageRoot && pageRoot.getAttribute('data-section-id');

  function isOpen() { return !!(drawer && drawer.isOpen()); }
  function open(from) {
    if (!drawer) { location.href = (NP.routes && NP.routes.cart) || '/cart'; return; }
    drawer.open(from);
  }
  function close(now) { if (drawer) drawer.close(now); }

  /* Fresh contents in place: the focus stays where it was, the free shipping line runs from where it was to where it
     is now (and splashes once it is full), and the boxes are counted everywhere */
  function swap(holder, html, fresh) {
    if (!holder || !html) return null;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var next = $('[data-cart-root]', doc);
    var cur = $('[data-cart-root]', holder);
    if (!next || !cur) return null;
    var focused = document.activeElement, keep = null;
    if (focused && holder.contains(focused)) {
      var line = focused.closest('[data-key]');
      keep = { key: line && line.getAttribute('data-key'), dir: focused.getAttribute('data-dir'), rm: focused.hasAttribute('data-remove') };
    }
    var oldTube = $('[data-cv-tube]', cur), was = oldTube ? parseFloat(oldTube.style.getPropertyValue('--fill')) : NaN;
    cur.replaceWith(next);
    var tube = $('[data-cv-tube]', next);
    if (tube && !isNaN(was) && !reduce) {
      var to = parseFloat(tube.style.getPropertyValue('--fill'));
      if (to !== was) {
        tube.style.setProperty('--fill', String(was));
        void tube.offsetWidth;
        tube.style.setProperty('--fill', String(to));
        if (to >= 1 && was < 1) tube.classList.add('splash');
      }
    }
    if (fresh) {
      var row = $('[data-key="' + fresh + '"]', next);
      if (row) { row.classList.add('is-new'); setTimeout(function () { row.classList.remove('is-new'); }, 1600); }
    }
    if (keep) {
      var target = null;
      if (keep.key) {
        var row2 = $('[data-key="' + keep.key + '"]', next);
        if (row2) target = keep.dir ? $('[data-dir="' + keep.dir + '"]', row2) : $('[data-remove]', row2);
      }
      target = target || $('[data-close]', holder) || $('h1', holder);
      if (target) target.focus({ preventScroll: true });
    }
    return next;
  }
  function render(sections, fresh) {
    if (!sections) return;
    var next = swap(panel, sections[SECTION], fresh);
    if (pageRoot && pageSection && sections[pageSection]) swap(pageRoot, sections[pageSection]);
    next = next || $('[data-cart-root]', panel);
    if (next) count(Number(next.getAttribute('data-count')) || 0);
  }
  function sectionList() { return pageSection ? SECTION + ',' + pageSection : SECTION; }

  function count(n) {
    $$('[data-cart-count]').forEach(function (el) { el.textContent = n ? String(n) : ''; });
    $$('[data-cart-chip]').forEach(function (el) {
      el.hidden = !n;
      el.innerHTML = n ? n + '<span class="sr"> ' + (n === 1 ? t('box_one') : t('box_other')) + '</span>' : '';
    });
    $$('[data-cart-btn]').forEach(function (el) { el.setAttribute('aria-label', n ? plural('cart', n) : t('cart_empty')); });
    NP.count = n;
    document.dispatchEvent(new CustomEvent('np:cart', { detail: { count: n } }));
  }

  function busy(on) { if (dlg) dlg.classList.toggle('is-busy', on); if (pageRoot) pageRoot.classList.toggle('is-busy', on); }
  function say(msg) {
    if (!status) return;
    status.textContent = '';
    setTimeout(function () { status.textContent = msg; }, 60);
  }

  /* ---------- The cart ---------- */
  // from: the button pressed; the drop flies from it into the bag while the boxes go in, then the drawer comes up
  function add(id, qty, info, from) {
    qty = Math.max(1, Number(qty) || 1);
    var flown = new Promise(function (done) { if (from && NP.flyToCart && !isOpen()) NP.flyToCart(from, done); else done(); });
    var sent = request(NP.routes.add + '.js', { items: [{ id: Number(id), quantity: qty }], sections: sectionList() });
    return Promise.all([sent, flown]).then(function (r) {
      var d = r[0], item = (d.items && d.items[0]) || d;
      render(d.sections, item.key);
      var title = (info && info.title) || item.product_title || '';
      var msg = plural('added', qty, { title: title });
      say(msg);
      open(from);
      track('np_add_to_cart', {
        variant: Number(id),
        quantity: qty,
        value: ((item.final_price || item.price || 0) * qty) / 100,
        currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || undefined
      });
      return { item: item, message: msg };
    });
  }

  function change(key, qty) {
    busy(true);
    return request(NP.routes.change + '.js', { id: key, quantity: Math.max(0, Number(qty) || 0), sections: sectionList() })
      .then(function (d) { render(d.sections); return d; })
      .catch(function (e) { NP.toast(e.shown || t('error')); throw e; })
      .then(function (d) { busy(false); return d; }, function (e) { busy(false); throw e; });
  }

  /* After the back button or another tab, the cart shows what it holds now */
  function refresh() {
    var base = (NP.routes && NP.routes.root) || '/';
    var url = base + (base.indexOf('?') < 0 ? '?' : '&') + 'sections=' + sectionList();
    return fetch(url, { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : {}; })
      .then(function (d) { if (d && d[SECTION]) render(d); })
      .catch(function () { /* the page still works with the cart it was drawn with */ });
  }

  document.addEventListener('click', function (e) {
    var el = e.target.closest('[data-open-cart],[data-cv-shop],[data-step],[data-remove],[data-add-variant]');
    if (!el) return;
    if (el.hasAttribute('data-open-cart')) {
      e.preventDefault();
      // on the cart page the cart is the page itself
      if (pageRoot) { scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' }); return; }
      open(el);
      return;
    }
    if (el.hasAttribute('data-cv-shop')) {
      // the empty cart's button: to the buy on this page when there is one
      var target = document.getElementById('buy');
      if (target && isOpen()) {
        e.preventDefault();
        close();
        setTimeout(function () { target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth' }); }, reduce ? 0 : 340);
      }
      return;
    }
    var row = el.closest('[data-key]'), key = el.getAttribute('data-line') || (row && row.getAttribute('data-key'));
    if (el.hasAttribute('data-step') && key) { change(key, Number(el.getAttribute('data-step'))).catch(function () {}); return; }
    if (el.hasAttribute('data-remove') && key) { change(key, 0).catch(function () {}); return; }
    if (el.hasAttribute('data-add-variant')) {
      el.disabled = true;
      add(el.getAttribute('data-add-variant'), 1)
        .catch(function (err) { NP.toast(err.shown || t('error')); })
        .then(function () { el.disabled = false; });
    }
  });

  // a product form with data-np-add («Όλα τα αρώματα»'s cards): its box goes in through the cart, the drop flying from
  // its button; without this script the form posts as it is
  document.addEventListener('submit', function (e) {
    var form = e.target.closest && e.target.closest('form[data-np-add]');
    if (!form) return;
    var id = form.querySelector('[name="id"]'), btn = form.querySelector('[type="submit"]');
    if (!id) return;
    e.preventDefault();
    if (btn) btn.disabled = true;
    add(id.value, 1, { title: form.getAttribute('data-title') || '' }, btn)
      .catch(function (err) { NP.toast(err.shown || t('error')); })
      .then(function () { if (btn) btn.disabled = false; });
  });

  addEventListener('pageshow', function (e) { if (e.persisted) refresh(); });

  window.NPCart = { add: add, change: change, open: open, close: close, refresh: refresh, isOpen: isOpen, deal: deal, money: money, t: t, plural: plural, toast: NP.toast, track: track };
  NP.track = track;
})();
